import { useRevisaoGantt } from "./use-revisao-gantt";
import { RevisaoGanttView } from "./view-revisao-gantt";
import type { RevisaoGanttProps } from "./types-revisao-gantt";

export function RevisaoGantt(props: RevisaoGanttProps) {
  const vm = useRevisaoGantt(props);

  return <RevisaoGanttView {...vm} />;
}

export type { GanttPeriodoEntrada } from "./revisao-gantt.model";
export type * from "./types-revisao-gantt";
